import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import listenToPostScroll from './listenToPostScroll';

const usePostChromeVisible = () => {
  const isMobile = useIsSize(Sizes.SM);
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const [visible, setVisible] = useState(true);
  const prevScrollTop = useRef(0);

  useEffect(() => {
    if (isMobile) {
      const listener = _.throttle(({ scrollTop }) => {
        if (scrollTop < 0 || scrollTop === prevScrollTop.current) {
          return;
        }

        // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
        const scrolledUp = scrollTop < prevScrollTop.current;
        if (scrolledUp) {
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
          const scrolledUpEnough = prevScrollTop.current - scrollTop >= 10;
          if (scrolledUpEnough) {
            setVisible(true);
          }
        } else {
          setVisible(false);
        }

        prevScrollTop.current = scrollTop;
      }, 200);
      const removeListener = listenToPostScroll(listener);
      return () => {
        removeListener();
        listener.cancel();
      };
    }

    setVisible(true);
    return undefined;
  }, [isMobile]);

  return visible;
};

export default usePostChromeVisible;
